const PADDING_SIZES = {
  small: "8px 16px",
  medium: "12px 20px",
  large: "18px 32px"
}

const ROUNDED_CORNER_RADII = {
  none: "0px",
  small: "4px",
  large: "10px",
  full: "999999px"
}

const BORDERS_SIZES = {
  small: "1px",
  medium: "3px",
  large: "5px"
}

const FONT_SIZE_MULTIPLIERS = {
  small: 0.75,
  medium: 1,
  large: 1.5
}

const MARGINS = {
  small: 4,
  medium: 8,
  large: 12
}

const normalizeRadius = radius => {
  if (radius > 0 && radius <= 4) {
    return "small"
  } else if (radius > 4 && radius <= 10) {
    return "large"
  } else if (radius > 10) {
    return "full"
  } else {
    return "default"
  }
}

const widthValue = width => {
  if (typeof width !== "number") return width
  return width < 75 ? "auto" : "100%"
}

export default function getStyles({
  alignment = "center",
  backgroundColor = "#1e1e1e",
  borderRadius,
  color = "#ffffff",
  margin,
  width,
  size = "medium",
  borderSize = "small",
  borderColor,
  roundedCornerOption = "small"
}) {
  const style = {
    backgroundColor,
    boxSizing: "border-box",
    borderRadius: ROUNDED_CORNER_RADII[roundedCornerOption],
    borderStyle: "solid",
    borderWidth: BORDERS_SIZES[borderSize],
    borderColor,
    color,
    display: width === "100%" ? "block" : "inline-block",
    width: widthValue(width),
    textAlign: alignment,
    textDecoration: "none",
    padding: PADDING_SIZES[size]
  }

  if (!style.borderRadius) {
    style.borderRadius = ROUNDED_CORNER_RADII[normalizeRadius(borderRadius)]
  }

  if (margin) {
    style.margin = `${margin}px 0`
  } else {
    style.margin = `${MARGINS[size]}px 0`
  }

  if (!style.borderColor) {
    style.borderColor = backgroundColor
  }

  style.fontSize = `${16 * FONT_SIZE_MULTIPLIERS[size]}px`

  return style
}
